import moment from 'moment';
import _ from 'lodash';

import { DATETIME_FORMAT } from 'global-constants';

export const getEventDateTimeData = (dateString, prefix) => {
  const dayVar = `${prefix}Day`;
  const monthVar = `${prefix}Month`;
  const timeVar = `${prefix}Time`;

  if (_.isNil(dateString) || _.isEmpty(dateString)) {
    return {
      [dayVar]: null,
      [monthVar]: null,
      [timeVar]: null
    };
  }

  const dateTime = moment(dateString, DATETIME_FORMAT);

  return {
    [dayVar]: dateTime.format('DD'),
    [monthVar]: dateTime.format('MMM').toUpperCase(),
    [timeVar]: dateTime.format('h:mm a')
  };
};
